import { Component, Input, OnInit } from '@angular/core';
import { KeycloakProfile } from 'keycloak-js';

@Component({
    selector: 'app-view-users-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.css'],
})
export class ImportComponent implements OnInit {
    @Input() public keycloakUsers: KeycloakProfile[] = [];
    constructor() {}

    ngOnInit(): void {}
}
